exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-269f433c] {\n  margin-bottom: 20px;\n}\n.el-col[data-v-269f433c] {\n  border-radius: 4px;\n}\n", ""]);

// exports
